exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proTitle[data-v-323772a3]{color:#ffffd8;font-weight:700;font-size:16px;text-align:center;background:#388e3c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-323772a3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/yearly_project_budget/yearly_pro_bud_details/insertForm.vue
// module id = 1198
// module chunks = 3